import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import Auth from '../components/Auth';
import AdminDashboard from '../components/AdminDashboard';

const AdminLayout: React.FC = () => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPasswordRecovery, setIsPasswordRecovery] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.passwordRecovery) {
      setIsPasswordRecovery(true);
    }

    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setIsPasswordRecovery(true);
        setSession(session);
        setLoading(false);
        return;
      }

      if (event === 'USER_UPDATED') {
        setIsPasswordRecovery(false);
      }

      if (event === 'SIGNED_IN' && session?.user && !session.user.email_confirmed_at) {
        setIsPasswordRecovery(true);
        setSession(session);
        setLoading(false);
        return;
      }

      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (isPasswordRecovery) {
    return <Auth forceResetMode />;
  }

  if (!session) {
    return <Auth />;
  }

  return <AdminDashboard />;
};

export default AdminLayout;
